import { ComposeActionKey, ReadActionKey, HoverActionKey } from 'owa-outlook-service-options';
import { ControlIcons } from 'owa-control-icons';
import { SurfaceActionIcons } from 'owa-surface-action-icons';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import { resolve as urlResolve } from 'url';
import { getIsDarkTheme } from 'owa-fabric-theme';

const SVG_BASE_PATH = 'resources/images/surfaceActions';

const ATTACH_SVG = `${SVG_BASE_PATH}/attach.svg`;
const ATTACHDARK_SVG = `${SVG_BASE_PATH}/attachDark.svg`;
const INLINEIMAGE_SVG = `${SVG_BASE_PATH}/inlineimage.svg`;
const INLINEIMAGEDARK_SVG = `${SVG_BASE_PATH}/inlineimageDark.svg`;
const EMOJI_SVG = `${SVG_BASE_PATH}/emoji.svg`;
const SHOWRIBBON_SVG = `${SVG_BASE_PATH}/showribbon.svg`;
const SHOWRIBBONDARK_SVG = `${SVG_BASE_PATH}/showribbonDark.svg`;

export interface SurfaceActionIcon {
    iconName: string;
    fallbackIconName: string;
    isImage: boolean;
}

export function getComposeActionIconName(key: ComposeActionKey): SurfaceActionIcon {
    let iconName: string;
    let fallbackIconName: string;
    let isImage = false;

    switch (key) {
        case 'AddAttachment':
            iconName = urlResolve(
                getPackageBaseUrl(),
                getIsDarkTheme() ? ATTACHDARK_SVG : ATTACH_SVG
            );
            fallbackIconName = urlResolve(getPackageBaseUrl(), ATTACH_SVG);
            isImage = true;
            break;
        case 'AddInlineImage':
            iconName = urlResolve(
                getPackageBaseUrl(),
                getIsDarkTheme() ? INLINEIMAGEDARK_SVG : INLINEIMAGE_SVG
            );
            fallbackIconName = urlResolve(getPackageBaseUrl(), INLINEIMAGE_SVG);
            isImage = true;
            break;
        case 'AddEmoji':
            iconName = urlResolve(getPackageBaseUrl(), EMOJI_SVG);
            isImage = true;
            break;
        case 'ToggleRibbon':
            iconName = urlResolve(
                getPackageBaseUrl(),
                getIsDarkTheme() ? SHOWRIBBONDARK_SVG : SHOWRIBBON_SVG
            );
            fallbackIconName = urlResolve(getPackageBaseUrl(), SHOWRIBBON_SVG);
            isImage = true;
            break;
        case 'ProtectMessage':
            iconName = SurfaceActionIcons.Encryption;
            break;
        case 'SaveDraft':
            iconName = ControlIcons.Save;
            break;
        case 'InsertSignature':
            iconName = SurfaceActionIcons.InsertSignatureLine;
            break;
        case 'ShowFrom':
            iconName = SurfaceActionIcons.ArrangeByFrom;
            break;
        case 'SetImportance':
            iconName = ControlIcons.Important;
            break;
        case 'ShowMessageOptions':
            iconName = ControlIcons.MailOptions;
            break;
        case 'SwitchBodyType':
            iconName = ControlIcons.OutlookLogo;
            break;
        case 'AccChecker':
            iconName = ControlIcons.OutlookLogo;
            break;
        default:
            iconName = '';
            break;
    }

    return {
        iconName,
        fallbackIconName: fallbackIconName || iconName,
        isImage,
    };
}

export function getReadActionIconName(key: ReadActionKey): SurfaceActionIcon {
    let iconName: string;

    switch (key) {
        case '-':
            iconName = '-';
            break;
        case 'Reply':
            iconName = ControlIcons.Reply;
            break;
        case 'ReplyAll':
            iconName = ControlIcons.ReplyAll;
            break;
        case 'Forward':
            iconName = ControlIcons.Forward;
            break;
        case 'ReplyByMeeting':
            iconName = ControlIcons.Calendar;
            break;
        case 'ReportAbuse':
            iconName = ControlIcons.ReportHacked;
            break;
        case 'Delete':
            iconName = ControlIcons.Delete;
            break;
        case 'MarkReadUnread':
            iconName = ControlIcons.Mail;
            break;
        case 'FlagUnflag':
            iconName = ControlIcons.Flag;
            break;
        case 'AssignPolicy':
            iconName = ControlIcons.Assign;
            break;
        case 'AddToSafeSenders':
            iconName = ControlIcons.AddFriend;
            break;
        case 'MarkJunkNotJunk':
            iconName = ControlIcons.MailAlert;
            break;
        case 'MarkAsPhishing':
            iconName = SurfaceActionIcons.Phishing;
            break;
        case 'Block':
            iconName = ControlIcons.BlockContact;
            break;
        case 'CreateRule':
            iconName = SurfaceActionIcons.CreateMailRule;
            break;
        case 'Print':
            iconName = ControlIcons.Print;
            break;
        case 'Translate':
            iconName = ControlIcons.LocaleLanguage;
            break;
        case 'ShowInImmersiveReader':
            iconName = SurfaceActionIcons.ReadOutLoud;
            break;
        case 'ViewMessageSource':
            iconName = ControlIcons.OpenSource;
            break;
        case 'Popout':
            iconName = ControlIcons.OpenInNewWindow;
            break;
        case 'LikeUnlike':
            iconName = ControlIcons.Like;
            break;
        case 'ToggleDarkMode':
            iconName = ControlIcons.Sunny;
            break;
        default:
            iconName = '';
            break;
    }

    return {
        iconName,
        fallbackIconName: iconName,
        isImage: false,
    };
}

export function getHoverActionIconName(key: HoverActionKey): SurfaceActionIcon {
    let iconName: string;
    switch (key) {
        case '-':
            iconName = '-';
            break;
        case 'Delete':
            iconName = ControlIcons.Delete;
            break;
        case 'Archive':
            iconName = ControlIcons.Archive;
            break;
        case 'PinUnpin':
            iconName = ControlIcons.Pinned;
            break;
        case 'ReadUnread':
            iconName = ControlIcons.Mail;
            break;
        case 'FlagUnflag':
            iconName = ControlIcons.Flag;
            break;
        case 'Move':
            iconName = ControlIcons.FabricFolder;
            break;
        default:
            iconName = '';
            break;
    }
    return {
        iconName,
        fallbackIconName: iconName,
        isImage: false,
    };
}
